namespace RioERP.Common {
    export interface SMSRow {
        SmsId?: number;
        Uid?: string;
        Subject?: string;
        Body?: string;
        SmsFrom?: string;
        SmsTo?: string;
        ReplyTo?: string;
        Cc?: string;
        Bcc?: string;
        Priority?: SMSQueuePriority;
        Status?: SMSStatus;
        RetryCount?: number;
        ErrorMessage?: string;
        LockExpiration?: string;
        SentDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        AwsUserId?: string;
        AwsPassword?: string;
        ApiKey?: string;
        Sender?: string;
        EntityId?: string;
        TemplateId?: string;
    }

    export namespace SMSRow {
        export const idProperty = 'SmsId';
        export const nameProperty = 'Subject';
        export const localTextPrefix = 'Common.SMS';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SmsId = "SmsId",
            Uid = "Uid",
            Subject = "Subject",
            Body = "Body",
            SmsFrom = "SmsFrom",
            SmsTo = "SmsTo",
            ReplyTo = "ReplyTo",
            Cc = "Cc",
            Bcc = "Bcc",
            Priority = "Priority",
            Status = "Status",
            RetryCount = "RetryCount",
            ErrorMessage = "ErrorMessage",
            LockExpiration = "LockExpiration",
            SentDate = "SentDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            AwsUserId = "AwsUserId",
            AwsPassword = "AwsPassword",
            ApiKey = "ApiKey",
            Sender = "Sender",
            EntityId = "EntityId",
            TemplateId = "TemplateId"
        }
    }
}
